import { API_URL, Socket_Port } from "BaseUrl";
import addDeleteGetLocalStorage from "global-modules/addDeleteGetLocalStorage";
import io from "socket.io-client";
import { STORAGE } from "tutorEnum";
const token = addDeleteGetLocalStorage(STORAGE.TOKEN, {}, "get", "single");

let connectionOptions = {
  transports: ["websocket"],
  pingInterval: 1000 * 60 * 10,
  pingTimeout: 1000 * 60 * 7,
  withCredentials: true,
  extraHeaders: {
    authorization: `Bearer ${token}`, // Add your custom header here
  },
  query: {
    authorization: `Bearer ${token}`, // Add your custom header here
  },
};

const socket = io(
  `${API_URL}:${Socket_Port}?authorization=${token}`,
  connectionOptions
);

socket.on("connect", () => {
  console.log("✅ WebSocket connected!", socket.id);
});

socket.on("connect_error", (error) => {
  console.error("❌ WebSocket connection error:", error);
});

socket.on("disconnect", (reason) => {
  console.warn("⚠️ WebSocket disconnected:", reason);
});

export default socket;
